<template>
	<section
		class="py-20 xl:pt-[120px] xl:pb-[60px] relative will-change three-box-card"
		:data-scroll-section="inner == 'false'"
	>
		<div class="px-content mb-12">
			<h2 class="text-4xl xl:text-heading mb-8" v-show="blockData.title">
				{{ blockData.title }}
			</h2>
			<div
				class="block-text xl:max-w-[40vw]"
				v-show="blockData.text"
				v-html="blockData.text"
			></div>
		</div>
		<!-- card list -->
		<div
			class="px-content grid md:grid-cols-3 xl:flex w-full gap-5 xl:gap-6 xl:justify-start"
			:class="cardNumber()"
		>
			<!-- Normal style -->
			<template v-if="blockData.style !== 'alternate'">
				<component
					:is="card.cta?.url ? 'a' : 'div'"
					v-for="(card, index) in filteredCards"
					:key="index"
					class="card-toponyms block cursor-pointer"
					:href="card.cta?.url || null"
				>
					<div class="overflow-hidden relative">
						<img
							class="object-cover w-full"
							v-if="card.image"
							:src="card.image.sizes.customslide"
							:alt="card.image.alt"
						/>
					</div>

					<div
						class="card-toponyms__txt"
						:class="{ 'card-toponyms__txt--nopicto': !card.icon }"
					>
						<div class="picto picto-toponyms mb-5" v-if="card.icon">
							<img :src="card.icon.url" :alt="card.icon.alt" />
						</div>

						<h4 class="text-2xl tracking-[1px] mb-5" v-if="card.title">
							{{ card.title }}
						</h4>

						<div
							class="block-text mb-8 text-sm"
							v-if="card.text"
							v-html="card.text"
						></div>
						<a
							v-if="card.cta_type === 'File' && card.file"
							class="uppercase text-xs tracking-little text-navy-blue-02 mt-auto"
							href=""
							@click="openBlank(card.file.url)"
							>{{ __("DOWNLOAD", "ccave") }}</a
						>
						<span
							v-if="card.cta?.title"
							class="uppercase text-xs tracking-little text-navy-blue-02 mt-auto"
						>
							{{ card.cta.title }}
						</span>
					</div>
				</component>
			</template>

			<!-- Alternate style -->
			<template v-else>
				<div
					class="card-toponyms pt-10"
					v-for="(card, index) in blockData.cards"
					:key="index"
				>
					<img
						class="self-center border-[3px] border-light-blue-01 rounded-full mb-4 mt-[14px]"
						v-if="card.image"
						:src="card.image.sizes.thumbnail"
						:alt="card.image.alt"
					/>
					<div class="card-toponyms__txt card-toponyms__txt--nopicto">
						<h4
							class="text-2xl tracking-[1px] text-center mb-5"
							v-if="card.title"
							v-html="card.title"
						></h4>
						<div
							class="block-text text-sm text-center mb-8"
							v-if="card.text"
							v-html="card.text"
						></div>
					</div>
				</div>
			</template>
		</div>
		<!-- ./card list -->
	</section>
</template>

<script>
export default {
	name: "ThreeCardsText",
	props: {
		blockData: {
			type: Object,
			required: true,
		},
	},
	computed: {
		filteredCards() {
			if (!this.blockData?.cards) return [];
			return this.blockData.cards;
		},
	},
	methods: {
		goToLocation(card) {
			window.location.href = card.cta.url;
		},
		openBlank(link) {
			window.open(link, "_blank");
		},
		cardNumber() {
			let cardClasses = "";
			if (this.blockData.cards && this.blockData.cards.length > 4) {
				cardClasses = "xl:flex-wrap";
			}
			return cardClasses;
		},
	},
};
</script>
